import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

interface Props {
  iconName: string,
  size?: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SvgIcon',
  props: {
    iconName: null,
    size: null
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as {
  iconName: string,
  size?: string,
}



const svgName = computed((): string => `${props.iconName}`);
const svgClass = computed((): string => {
  const validate = props.size && ['large', 'medium', 'small'].includes(props.size);
  const size = validate ? props.size : 'large';
  return `svg-icon ${size}-icon ${svgName.value}`;
});

function handleClick(event: Event) {
  emit('click', event)
}


return { __sfc: true,props, emit, svgName, svgClass, handleClick }
}

})